import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import React, { memo } from 'react';
import useSearchApi from './useSearchApi.js';

var _excluded = ["children", "onClick", "tabIndex"];
var _templateObject;
var StyledSearchResult = styled__default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: none;\n  display: block;\n  font-size: 1rem;\n  padding: 1rem 1.5rem;\n  text-align: left;\n  width: 100%;\n  background-color: #fff;\n\n  &:hover,\n  &:focus {\n    background: #f8f8f8;\n    cursor: pointer;\n  }\n"])));
var SearchResult = function SearchResult(_ref) {
  var children = _ref.children,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSearchApi = useSearchApi(),
    hideResults = _useSearchApi.hideResults;
  var handleClick = function handleClick(e) {
    onClick(e);
    hideResults();
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === 32) {
      e.preventDefault();
      // @ts-ignore
      onClick(e);
      hideResults();
    }
  };
  return /*#__PURE__*/React.createElement(StyledSearchResult, _extends({
    onClick: handleClick,
    tabIndex: tabIndex,
    role: 'button',
    onKeyDown: handleKeyDown
  }, rest), children);
};
var SearchResult$1 = /*#__PURE__*/memo(SearchResult);

export default SearchResult$1;
